<template>
  <div id="submit-manuscripts-upload-documents">
    <div class="ipub-h2 mar-b-20">
      <div class="ipub-p2 fw-bd">Tips</div>
      <div class="ipub-p2">
        1. The uploaded files must contain a cover letter and an editable manuscript. The template file can be downloaded in <a download
           class="link-color"
           target="_blank"
           :href="`${domain}/${manuscript.journal&&manuscript.journal.wordTemplate}`">Microsoft Word</a>.
        <!--  or <a download
           class="link-color"
           target="_blank"
           :href="`${domain}/${manuscript.journal&&manuscript.journal.latexTemplate}`">LaTex format</a>.  -->
        You should read the “<a class="link-color"
           target="_blank"
           :href="manuscript.journal&&manuscript.journal.authorGuide">Author Instructions</a>” for more detailed information.<br />
        2. The total file size including all documents must not exceed 200 MB. If you have any questions, please contact the editorial department <a class="link-color"
           target="_blank"
           :href="`mailto:${manuscript.journal&&manuscript.journal.contactEmail}`">{{manuscript.journal&&manuscript.journal.contactEmail}}</a><br />
        <font class="key-color">3. If you have multiple files of one type (Figures / Videos / Supplementary Material), please create a zip file and upload individually.
        </font>
      </div>
    </div>
    <div class="upload-content mar-b-30">
      <div class="ipub-h2 mar-b-12">Upload Files</div>
      <ipub-row :gutter="30">
        <ipub-col :span="6"
                  v-for="item in fileTypes"
                  :key="item.id">
          <div class="mar-b-30">
            <div class="mar-b-4 ipub-p2 fw-bd relative">
              {{item.typeName}}
              <font v-if="item.required"
                    class="key-color">*</font>
              <ipub-tooltip placement="right"
                            type="dark"
                            class="mar-l-10">
                <div slot="title">Supported file types: {{item.typeFile}}
                  <div v-if="item.typeName==='Figure'">Please upload as ZIP file for more than one figure.</div>
                  <div v-if="item.typeName==='Video'">Please upload as ZIP file for more than one video.</div>
                  <div v-if="item.typeName==='Supplementary File'">Please upload as ZIP file for more than one supplementary file.</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <!-- <div class="right-option">
                <ipub-upload v-if="!item.file"
                             @change="(e)=>{handleUpload(item, e)}"
                             class="mar-b-16">
                  <a class="link-color">Add</a>
                </ipub-upload>
                <font class="line-color"
                      v-else>Add</font>
              </div> -->
            </div>
            <div class="ipub-line-block ipub-border relative">
              <div style="width: calc(100% - 60px)"
                   class="omis">
                <a @click="download(item.file)"
                   v-if="item.file.name">{{item.file.name}}</a>
                <ipub-upload v-else
                             class="ipub-c-p"
                             style="width:100%"
                             @change="(e)=>{handleUpload(item, e)}">
                  <a class="line-color">Click to upload {{item.typeName}}</a>
                </ipub-upload>
              </div>
              <div class="right-option ipub-p4 flex"
                   v-if="item.file.name"
                   style="right: 10px">
                <ipub-tooltip placement="bottom">
                  <div slot="title">
                    Replace
                  </div>
                  <ipub-upload v-if="true"
                               class="line-h-40"
                               @change="(e)=>{handleUpload(item, e)}">
                    <a>
                      <ipub-icon style="font-size:16px"
                                 type="iconReplace" />
                    </a>
                  </ipub-upload>
                </ipub-tooltip>
                <div style="padding: 0 4px"
                     class="line-color line-h-40">|</div>
                <ipub-tooltip placement="bottom">
                  <div slot="title">
                    Delete
                  </div>
                  <a class="line-h-40"
                     @click="del(item)">
                    <ipub-icon style="font-size:16px"
                               type="iconDelete" />
                  </a>
                </ipub-tooltip>
              </div>
            </div>
          </div>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-button plain
                     style="width:150px"
                     @click="() => { $router.back(-1)}"
                     type="primary">Previous</ipub-button>
        <ipub-button type="primary"
                     :style="{ minWidth: '150px' }"
                     @click="submit">Save & Next</ipub-button>
      </div>
    </div>
    <!-- 步骤条 -->
    <!-- <ipub-model width="400px"
                height="300px"
                :showFooter="false"
                :showHeader="false"
                :visable="isVisable"
                @cancel="cancel">
      <ipub-progress class="mar-b-10"
                     :progress="progress.progress"
                     :type="progress.status" />
    </ipub-model> -->
    <Loading :isVisable="loading"
             @cancel="cancel"
             :ftype="ftype"
             :hasUploadFiles="hasUploadFiles"
             :progress="uploadProgress" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
